import NearestsStops from 'js/pages/nearests-stops/index.js'
import Routes from 'js/pages/routes/index.js'
import Stops from 'js/pages/stops/index.js'
import PointOfSales from 'js/pages/point-of-sales/index.js'
import Planner from 'js/pages/planner/index.js'
import ServiceChannel from 'js/pages/citizen/messages/index/index.js'
import clientShow from 'js/pages/citizen/messages/show/index.js'

const meta = {
  fixedLayout: true,
  watchPosition: true
}

export default [
  {
    path: 'nearests-stops',
    name: 'municipality-nearests-stops',
    component: NearestsStops,
    meta
  },
  {
    path: 'routes',
    name: 'municipality-routes',
    component: Routes,
    meta
  },
  {
    path: 'stops',
    name: 'municipality-stops',
    component: Stops,
    meta
  },
  {
    path: 'point-of-sales',
    name: 'municipality-point-of-sales',
    component: PointOfSales,
    meta
  },
  {
    path: 'planner',
    name: 'municipality-planner',
    component: Planner,
    meta
  },
  {
    path: 'service-channel',
    name: 'municipality-service-channel',
    component: ServiceChannel,
    meta
  },

  {
    path: 'client_show',
    name: 'municipality-client_show',
    component: clientShow,
    meta
  }
]
